import styles from './Balance.module.scss';
import { useGetBalanceDeliveryman } from '@/_features/motoboys/api/get-balance-deliveryman';
import { useGetBalancePlace } from '@/_features/places/api/get-balance-place';
import { Skeleton } from '@/_config/lib/react-native-skeleton';

function Balance({
  placeId,
  deliverymanId,
}: {
  placeId?: string;
  deliverymanId?: string;
}) {
  const { data: balanceDeliveryman, isFetching: isFetchingBalanceDeliveryman } =
    useGetBalanceDeliveryman(
      { deliverymanId: deliverymanId || '' },
      {
        enabled: !!deliverymanId,
      },
    );

  const { data: balancePlace, isFetching: isFetchingBalancePlace } =
    useGetBalancePlace(
      { placeId: placeId || '' },
      {
        enabled: !!placeId,
      },
    );

  const balance = balanceDeliveryman || balancePlace;
  const isLoading = isFetchingBalanceDeliveryman || isFetchingBalancePlace;

  return (
    <div
      className={`${styles.balance} ${
        balance
          ? balance.value > 0
            ? styles.credit
            : balance.value < 0
            ? styles.debit
            : ''
          : ''
      }`}
    >
      {!isLoading && balance ? (
        <span>Saldo atual: {balance.currency}</span>
      ) : (
        <Skeleton height={17} borderRadius={8} width="15vw" />
      )}
    </div>
  );
}

export default Balance;
